import Vue from 'vue'

import { account as api } from '@/backend/api'
import { stateAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  invoice: {},
  invoice_due: {},
  payment: {},
  subscriptions: {},
  customer: {},
  metrics: {},
  // respuestas memorizadas de los consumidores que piden cache: true, para que
  // un remonte del componente no vuelva a golpear la API. No se persiste, así
  // que se limpia al recargar
  cached: {},
  ...stateAbstract
}

const actions = {
  GET: ({ commit, state }, { resource, query, cache = false }) => {
    const key = `${resource}?${JSON.stringify(query || {})}`

    if (cache && state.cached[key]) {
      return Promise.resolve(state.cached[key])
    }

    return new Promise((resolve, reject) => {
      commit('SET_LOADER', 'retrieve')
      api.get(resource, query)
      .then(response => {
        commit('SET', { response: response, resource: resource })

        if (cache) {
          commit('SET_CACHED', { key: key, data: response.data })
        }

        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

const mutations = {
  SET_CACHED: (state, { key, data }) => {
    Vue.set(state.cached, key, { data: data })
  },
  SET: (state, { response, resource }) => {
    const r = resource.split('/').pop()
    if (state[r]) {
      state[r] = response.data
    }
    state.retrieveLoader = false
    state.createLoader = false
  },
  ...mutationsAbstract
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
